import { CssBaseline, ThemeProvider } from "@mui/material"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { Amplify, Hub } from "@aws-amplify/core"
import frLocale from "date-fns/locale/fr"
import React, { useEffect } from "react"
import "./App.scss"
import { CachingHelper } from "./app/components/ifc-displayer/helpers/CachingHelper"
import { LoadingCursorContextProvider } from "./app/components/GlobalLoadingStyle/LoadingCursorContext"
import ErrorBoundary from "./app/components/layout/error-boundary"
import { PhoneScreenGuard } from "./app/components/layout/PhoneScreenGuard"
import { authConfiguration } from "./app/core/authConfiguration"
import { OrganizationContextProvider } from "./app/core/context/organization/OrganizationContext"
import { useStrayFileDropGuard } from "./app/core/hooks/use-stray-file-drop-guard"
import { TokenContextProvider } from "./app/core/context/user/TokenContext"
import { UserContextProvider } from "./app/core/context/user/UserContext"
import { AppRouter } from "./app/router/AppRouter"
import { theme } from "./theme"

Amplify.configure(authConfiguration)

function listener(data: any): void {
  switch (data.payload.event) {
    case "signIn":
      break
    case "signUp":
      break
    case "signOut":
      break
    case "signIn_failure":
      console.info("user sign in failed")
      break
    case "tokenRefresh":
      console.info("token refresh succeeded")
      break
    case "tokenRefresh_failure":
      console.info("token refresh failed")
      break
    case "configured":
      console.info("the Auth module is configured")
      break
    default:
      break
  }
}

Hub.listen("auth", listener)

export default function App(): React.JSX.Element {
  // Application-wide, because a file can be dropped anywhere, not only on the pages that ask for one.
  useStrayFileDropGuard()
  // The maquette files the app used to keep in the browser are never read anymore (US 2545): their space is given back.
  useEffect(() => {
    CachingHelper.dropIfcCaches().catch(() => undefined)
  }, [])

  return (
    <ErrorBoundary>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
        <ThemeProvider theme={theme}>
          <CssBaseline>
            <PhoneScreenGuard>
              <LoadingCursorContextProvider>
                <TokenContextProvider>
                  <UserContextProvider>
                    <OrganizationContextProvider>
                      <AppRouter />
                    </OrganizationContextProvider>
                  </UserContextProvider>
                </TokenContextProvider>
              </LoadingCursorContextProvider>
            </PhoneScreenGuard>
          </CssBaseline>
        </ThemeProvider>
      </LocalizationProvider>
    </ErrorBoundary>
  )
}
